import { FiBriefcase, FiDownload, FiMail } from "react-icons/fi";
import { RiTeamLine } from "react-icons/ri";
import {
  FaGraduationCap,
  FaLightbulb,
  FaHandsHelping,
  FaChartLine,
  FaMapMarkerAlt,
  FaEnvelope,
  FaDesktop,
  FaPhoneAlt,
  FaUserCog,
} from "react-icons/fa";
import { BsCalendarCheck, BsEnvelope } from "react-icons/bs";

//src/components/mainLayout/Header.jsx
export const NavItems = [
  { name: "Home", link: "/" },
  {
    name: "About Us",
    items: [
      {
        title: "About Us",
        icon: <RiTeamLine />,
        link: "/aboutus",
      },
      {
        title: "Board of Directors",
        icon: <RiTeamLine />,
        link: "/management",
      },
      { title: "CEO Desk", icon: <RiTeamLine />, link: "/ceodesk" },
    ],
  },
  {
    name: "Our Solutions",
    items: [
      {
        key: "onex",
        title: "OneX Solution",
        icon: "📊", // Analytics / Dashboard
        link: "/oursolutions/onex",
        image: "/solutions/onex.webp",
        img: "/",
        img1: "/",
      },
      {
        key: "qpms",
        title: "QPMS",
        icon: "📋", // Forms / Records
        link: "/oursolutions/qpms",
        image: "/solutions/qpms.png",
        img: "/",
        img1: "/",
      },
      {
        key: "onmark",
        title: "Onmark",
        icon: "💻", // Software / Module
        link: "/oursolutions/onmark",
        image: "/solutions/onma.webp",
        img: "/",
        img1: "/",
      },
      {
        key: "ezytest",
        title: "Ezy test",
        icon: "🧪", // Test / Experiment
        link: "/oursolutions/ezytest",
        image: "/solutions/ezy.webp",
        img: "/",
        img1: "/",
      },
      {
        key: "digitab",
        title: "Digitab",
        icon: "📚", // Learning / Language
        link: "/oursolutions/digitab",
        image: "/solutions/digl.png",
        img: "/",
        img1: "/",
      },
      {
        key: "ExamSurveillance",
        title: "Exam Surveillance",
        icon: "🔢", // Numbers / Digital
        link: "/oursolutions/digilab",
        image: "/solutions/ExamCenter.png",
        img: "/", //small icon
        img1: "/", //solution page icon
      },
      {
        key: "digitlab",
        title: "Digital LAB",
        icon: "🔢", // Numbers / Digital
        link: "/oursolutions/digilab",
        image: "/solutions/dilab.png",
        img: "/",
        img1: "/",
      },
    ],
  },
  { name: "Career", icon: <FiBriefcase />, link: "/career" },
  { name: "Contact Us", icon: <FiMail />, link: "/contact" },
];

// src/components/Home/solutions.jsx
export const services = [
  {
    id: 1,
    title: "End-to-End Solutions",
    description:
      "OneX transforms examinations with secure, seamless, scalable processes ensuring accuracy, insights, fairness, and efficiency.",
    icon: "/solutions/onex.webp",
    link: "/oursolutions/onex",
    delay: 0,
  },
  {
    id: 2,
    title: "Digital Evaluation",
    description:
      "Onmark offers secure cloud-based exam marking, ensuring integrity, speed, accuracy, analytics, and fraud-proof assessments.",
    icon: "/solutions/onma.webp",
    link: "/oursolutions/onmark",
    delay: 0.4,
  },
  {
    id: 3,
    title: "Paperless Examination",
    description:
      "DigiTAB provides paperless exams via tablets, encryption, biometric security, proctoring, credibility, affordability, scalability.",
    icon: "/solutions/dig.webp",
    link: "/oursolutions/digitab",
    delay: 0.4,
  },
  {
    id: 4,
    title: "Computer Based Test (CBT)",
    description:
      "EzyTest modernizes exams with seamless, secure online testing, advanced proctoring, robust security, and efficiency.",
    icon: "/solutions/ezy.webp",
    link: "/oursolutions/ezytest",
    delay: 0.2,
    active: true,
  },
  {
    id: 5,
    title: "Exam Surveillance Solution",
    description:
      "AI-powered exam surveillance detects cheating, ensures fairness, delivers alerts, analytics, tamper-proof logs, secure monitoring.",
    icon: "/solutions/ExamCenter.png",
    link: "/oursolutions/digilab",
    delay: 0.4,
  },
  {
    id: 6,
    title: "English Lab/Career Lab/Aptitude Lab",
    description:
      "DigitalLAB enhances communication, accent reduction, soft skills, employability, career readiness, academic success, confidence.",
    icon: "/solutions/dilab.png",
    link: "/oursolutions/digilab",
    delay: 0.4,
  },
];

// src/components/Home/Service.jsx
export const service = [
  {
    id: 1,
    title: "Onscreen Evaluation",
    description:
      "Digitally evaluate answer scripts with ease and efficiency, improving accuracy and turnaround time.",
    img: "/img4.avif",
    objectFit: "cover",
    bgColor: "bg-white",
  },
  {
    id: 2,
    title: "Question Paper Generator",
    description:
      "Automatically generate question papers tailored to curriculum and difficulty level requirements.",
    img: "/img6.png",
    objectFit: "contain",
    bgColor: "bg-[#f5f6fb]",
  },
  {
    id: 3,
    title: "OMR Evaluation",
    description:
      "Automate and streamline the evaluation of OMR sheets with high accuracy and speed.",
    img: "/img7.jpeg",
    objectFit: "fill",
    bgColor: "bg-white",
  },
];

// src/components/Home/HomeBlog.jsx
export const blogPosts = [
  {
    id: 1,
    category: "Guides & Teck Insights",
    title: "Necessity May Give Us Best Virtual Court Solutions",
    img: "/blog-image1.webp",
    excerpt:
      "Exploring how virtual court technologies are transforming legal proceedings and what this means for the future of justice.",
    comments: 0,
  },
  {
    id: 2,
    category: "Service-Specific Content",
    title: "Tackling the Changes in Retail Industry Teck",
    img: "/blog-image2.webp",
    excerpt:
      "How our retail solutions are helping businesses adapt to the rapid changes in consumer behavior and technology.",
    comments: 0,
  },
  {
    id: 3,
    category: "Product Updates & How-Tos",
    title: "Easy and Most Powerful Server Platform Updates",
    img: "/blog-image3.webp",
    excerpt:
      "Latest updates to our server platform with new integration tips to maximize your system's performance.",
    comments: 0,
  },
];

// src/components/Home/Awards.jsx
export const testimonials = [
  { id: 1, image: "/Award/1.JPG", title: "Business Icon award-2022" },
  { id: 2, image: "/Award/2.JPG", title: "Outlook business -2025" },
  { id: 3, image: "/Award/3.png", title: "20th Asia-Africa Business Award" },
  { id: 4, image: "/Award/4.jpg", title: "IETE-Corporate Award" },
  { id: 5, image: "/Award/5.jpg", title: "IETE-Corporate Award" },
  { id: 6, image: "/Award/6.jpg", title: "IETE-Corporate Award" },
];

// src/components/Home/FAQ.jsx
export const faqItems = [
  {
    question: "Email Support",
    answer: "Get responses within 1 business day",
    icon: "fas fa-envelope",
    image:
      "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  },
  {
    question: "Remote Help",
    answer: "Screen sharing for quick resolution",
    icon: "fas fa-desktop",
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  },
  {
    question: "Dedicated Phone Line",
    // answer: "Call +91-79953 44495 (9AM-6PM)",
    icon: "fas fa-phone-alt",
    image:
      "https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  },
  {
    question: "On-Site Assistance",
    answer: "Available for enterprise clients",
    icon: "fas fa-user-cog",
    image:
      "https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  },
];

// src/components/Home/OurCulture.jsx
export const jobOpenings = [
  {
    title: "PHP Developer",
    type: "Full-time",
    location: "Hyderabad",
    department: "Engineering",
    experience: "Any One",
    qualification: "Any Degree",
  },
  {
    title: "MBA Freshers",
    type: "Full-time",
    location: "Hyderabad",
    department: "Examinations",
    experience: "Freshers",
    qualification: "MBA (Any Stream)",
  },
];

// src/components/Home/OurCulture.jsx
export const culturePillars = [
  {
    icon: FaGraduationCap,
    title: "Continuous Learning",
    description:
      "Monthly tech talks, sponsored certifications, and skill development programs",
  },
  {
    icon: FaLightbulb,
    title: "Innovation Driven",
    description: "We encourage creative solutions to educational challenges",
  },
  {
    icon: FaHandsHelping,
    title: "Collaborative Spirit",
    description: "Flat hierarchy with open communication across all levels",
  },
  {
    icon: FaChartLine,
    title: "Growth Focused",
    description: "Clear career paths with regular progress reviews",
  },
];

// src/components/About/Management.jsx
export const directorsData = [
  {
    img: "/img9.jpg",
    name: "Prof. Sadagopan",
    role: "Chairman",
    description:
      "Founder Director, IIIT, Bangalore. Former Prof. IIT Kanpur and IIM, Bangalore.",
  },
  {
    img: "/img10.jpg",
    name: "M. Anantha Chary",
    role: "Promoter & Founder Director",
    description:
      "Experienced & Renowned Entrepreneur involved in the IT, Healthcare & BFSI Sector.",
  },
  {
    img: "/img12.jpg",
    name: "V S N Raju",
    role: "Managing Director & CEO",
    description: "Experienced IT Professional.",
  },
  {
    img: "/img13.jpg",
    name: "Dr. R. Jayaraman",
    role: "Director",
    description:
      "Member Secretary – CED, Tamil Nadu. Expert in Management Studies and Entrepreneurship.",
  },
  {
    img: "/img11.JPG",
    name: "A.V. Narayana",
    role: "Director",
    description: "Rtd., I.P.S. officer, C.I.D. Andhra Pradesh.",
  },
  // {
  //   img: "/img14.jpg",
  //   name: "B.S.V.S. Ramachander",
  //   role: "Vice President – Products",
  //   description: "Experienced IT Professional in Delivering Turnkey Solutions.",
  // },
];

// src/component/slidercomponent/SliderBanner.jsx for desktop
export const banner = [
  // "/assets/Banner-Designs/Frame1.png",
  // "/assets/Banner-Designs/Frame2.png",
  // "/banners/1.png",
  // "/banners/2.png",
  // "/banners/3.png",
  // "/banners/4.png",
  // "/banners/5.png",
  // "/banners/6.png",
  // "/banners/7.png",
  // "/banners/8.png",
  // "/banners/9.png",
  "/banner/1.png",
  "/banner/2.png",
  "/banner/3.png",
  "/banner/5.png",
];

// src/component/slidercomponent/SliderBanner.jsx for mobile

export const Mbanner = [
  // "/assets/Banner-Designs/Frame1.png",
  // "/assets/Banner-Designs/Frame2.png",
  // "/Mbanners/1.png",
  // "/Mbanners/2.png",
  // "/Mbanners/3.png",
  // "/Mbanners/4.png",
  // "/Mbanners/5.png",
  // "/Mbanners/6.png",
  // "/Mbanners/7.png",
  // "/Mbanners/8.png",
  // "/Mbanners/9.png",
  "/banner/1.png",
  "/banner/2.png",
  "/banner/3.png",
  "/banner/5.png",
];
